// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JobSeriesDetails-layout__cZHuX{display:flex;width:var(--size-full);height:var(--size-full)}.JobSeriesDetails-main__IlPD0{flex:1;overflow:auto}.JobSeriesDetails-sidebar__Hnkdm{display:flex;flex-direction:column;flex-shrink:0;gap:var(--size-4);height:var(--size-full);padding:var(--size-4);overflow:auto}@media only screen and (min-width: 64rem){.JobSeriesDetails-sidebar__Hnkdm{width:calc(var(--size-10)*10)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": "JobSeriesDetails-layout__cZHuX",
	"main": "JobSeriesDetails-main__IlPD0",
	"sidebar": "JobSeriesDetails-sidebar__Hnkdm"
};
export default ___CSS_LOADER_EXPORT___;
